module.exports = __webpack_public_path__ + "static/PrimitiveNine-ce6a32146b5dc8af57ec5a5d52aa3c32.png";